import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=03c63964&scoped=true&"
import script from "./SearchDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=03c63964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c63964",
  null
  
)

export default component.exports